(function () {
  if (window.vgcBound) return;
  window.vgcBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vgc-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var label = btn.dataset.label;
    var ui = document.querySelector('vs-cart-drawer') || document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: parseInt(btn.dataset.vgcAdd, 10), quantity: 1 }] };
    if (ui && typeof ui.getSectionsToRender === 'function') { body.sections = ui.getSectionsToRender().map(function (x) { return x.id; }); body.sections_url = location.pathname; }
    if (ui && typeof ui.setActiveElement === 'function') ui.setActiveElement(btn);
    var cfg = typeof fetchConfig === 'function' ? fetchConfig('json') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    cfg.body = JSON.stringify(body);
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', cfg)
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error('cart');
        if (ui && typeof ui.refresh === 'function') ui.refresh(true);
        else if (ui && typeof ui.renderContents === 'function') ui.renderContents(res.j);
        else { location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vs-grid', cartData: res.j });
        btn.classList.add('is-done');
      })
      .catch(function () {})
      .finally(function () { setTimeout(function () { btn.disabled = false; btn.classList.remove('is-done'); btn.textContent = label; }, 1800); });
  });
})();
